<template>
  <section class="section gyms">


    <div class="container timer has-text-centered">
      <img src="../assets/gyms.svg" alt=""></img>
      <br><br>
    </div>


    <div class="container" id="gymcard">

      <div class="tabs is-centered is-medium">
        <ul>

          <li>
            <a>
              <span id="is-static-city">Oslo</span>
            </a>
          </li>

          <li :class="{ 'is-active' : isActiveCity('Trondheim')}"  @click="setActiveCity('Trondheim')">
            <a>
              <span>Trondheim</span>
            </a>
          </li>

          <li nid="is-static-city">
            <a>
              <span id="is-static-city">Bergen</span>
            </a>
          </li>

          <li id="is-static-city">
            <a>
              <span id="is-static-city">Stavanger</span>
            </a>
          </li>

        </ul>
      </div>

      <div class="container" v-if="isActiveCity('Trondheim')">

        <div class="columns is-multiline">

          <!-- Shankha Yoga -->
          <div class="column is-one-quarter">


            <a class="container" @click="shankhaModal = true">
              <div class="card has-text-centered yoga-card">


                <div class="title is-4 card-text-test" id="gym-card-title-test">Shankha Yoga</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Yoga</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Midtbyen, Trondheim</div>


              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : shankhaModal}">
              <div class="modal-background" @click="shankhaModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-shankha">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Shankha Yoga og massasje
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Midtbyen, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Shankha Ayurveda og Yoga klinikk</h4>
                      <div class="modal-gym-para">
                        Shankha Yoga ligger midt i Trondheim sentrum og tilbyr varierte yogatimer av ypperste
                        klasse. I tillegg tilbyr Shankha yoga ulike behandlinger for mind-body velvære. Med sine
                        åtte erfarne instruktører,
                        et bredt tilbud av gruppetimer og koselige studio vil du føle deg velkommen.
                      </div> <br>
                      <h5 class="title is-5">Fasiliteter</h5>
                      <p class="modal-gym-para">Treningsmatte, <s>omkledningsrom</s>, <s>dusj</s></p>
                      <br>
                      <h5 class="title is-5">Kjekt å vite</h5>
                      <p class="modal-gym-para">Du trenger kun å ha på treningstøy og ta med vannflaske. La joggeskoene bli hjemme.</p>
                      <br>
                      <p class="modal-gym-para">Adresse:</p>
                      <p class="modal-gym-para">Kongens  Gate 21, 7013 Trondheim</p>
                      <br>
                      <a href="https://www.shankha.no/" class="subtitle is-5">https://www.shankha.no/</a>


                    </div>


                  </div>

                  <div class="column">

                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1784.5808348093813!2d10.38917551620976!3d63.43045578269488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d31a018e54fff%3A0xf279e0af57d2d638!2sShankha+Ayurveda+%26+Yoga!5e0!3m2!1sen!2sno!4v1520281207067" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>

                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="shankhaModal = false"></button>
            </div>




          </div>

          <!--Fitnesspoint-->
          <div class="column is-one-quarter">


            <a class="container" @click="fitnessModal = true">
              <div class="card has-text-centered fitness-card">


                <div class="title is-4 card-text-test" id="gym-card-title-test">Fitnesspoint</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Styrke og kondisjon</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Moholt, Trondheim</div>


              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : fitnessModal}">
              <div class="modal-background" @click="fitnessModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-fitness">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Fitnesspoint
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Moholt, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Fitnesspoint</h4>
                      <p class="modal-gym-para"> (Booking åpner uke 15.) <br>
                        Fitnesspoint er en kjede av selvbetjente treningssenter. Vi har nå 12 treningssenter rundt omkring i Norge og vi arbeider konkret med flere franchise-etableringer rundt om i landet.
                        Hos Fitnesspoint kommer du og går når du vil og du bestemmer selv over din trening. Du slipper å betale for dyre instruktører og fasiliteter du ikke benytter deg av.
                        Vi har et enkelt adgangssytem hvor du benytter ditt vanlige kredittkort som adgangskort.
                        Selv om det er billig å trene hos Fitnesspoint har vi ikke spart på utstyret. Hos oss finner du et rikt utvalg av tredemøller og annet kondisjonsutstyr, styrkeapparater, som dekker de fleste muskelgrupper, samt et rikt utvalg av frivekter.

                        <br><br><br>
                        <p class="modal-gym-para">Adresse:</p>
                        <p class="modal-gym-para">Brøsetvegen 186, 7048 Trondheim</p>
                        <br>
                        <a href="https://fitnesspoint.no" class="subtitle is-5">https://fitnesspoint.no</a>


                      </p>

                    </div>




                  </div>

                  <div class="column">

                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60516.81223508883!2d10.347194246959694!3d63.423592851964806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x44ec34f8a8733bef!2sFitnesspoint+Moholt+treningssenter!5e0!3m2!1sen!2suk!4v1521456574363" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="fitnessModal = false"></button>
            </div>




          </div>

          <!-- Yogaens hus -->
          <div class="column is-one-quarter">


            <a class="container" @click="yogaensModal = true">
              <div class="card has-text-centered yoga-card">



                <div class="title is-4 card-text-test" id="gym-card-title-test">Yogaens hus</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Yoga</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Ila, Trondheim</div>


              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : yogaensModal}">
              <div class="modal-background" @click="yogaensModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-shankha">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Yogaens hus
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Ilsvika, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Yogaens hus</h4>
                      <p class="modal-gym-para">
                        Yogaens Hus ligger ved sjøen i idylliske Ilsvika og med utsikt rett ut mot vakre Munkholmen.
                        Ingrid og Kari-Anne åpnet sommeren 2017 Yogaens Hus med et ønske om å skape et sted å lande,
                        pause ut, finne et pusterom i hverdagen. Ved Yogaens Hus ønsker vi å bidra til opplevelsen
                        av å være hel som menneske. Vi inviterer til et mangfold av ulike variasjoner av Yoga og
                        ønsker å tilby et inspirerende, inkluderende og trygt yogamiljø. Ved Yogaens Hus underviser
                        yogalærere med høy kvalitet, lang erfaring og solid kunnskap forankret i ulike yogatradisjoner.
                        Vi tilbyr yoga for alle og ønsker deg varmt velkommen.
                      </p>
                      <br>
                      <h5 class="title is-5">Fasiliteter</h5>
                      <p class="modal-gym-para">Treningsmatte, <s>omkledningsrom</s>, <s>dusj</s></p>
                      <br>
                      <h5 class="title is-5">Kjekt å vite</h5>
                      <p class="modal-gym-para">Du trenger kun å ha på treningstøy og ta med vannflaske. La joggeskoene bli hjemme.</p>
                      <br>
                      <br>
                      <p class="modal-gym-para">Adresse:</p>
                      <p class="modal-gym-para">Mellomila 91A, 7018 Trondheim</p>
                      <br>
                      <a href="https://www.yogaenshus.no/" class="subtitle is-5">https://www.yogaenshus.no/</a>


                    </div>




                  </div>

                  <div class="column">

                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1784.449631591226!2d10.350546216214832!3d63.432562382519436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d322f0b88d459%3A0x737e6e2ecdd90edc!2sYogaens+Hus+AS!5e0!3m2!1sen!2sno!4v1520460879577" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="yogaensModal = false"></button>
            </div>




          </div>

          <!-- Pilates Trondheim -->
          <div class="column is-one-quarter">


            <a class="container" @click="pilatesModal = true">
              <div class="card has-text-centered pilates-card">



                <div class="title is-4 card-text-test" id="gym-card-title-test">Pilates Trondheim</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Piltes</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Midtbyen, Trondheim</div>


              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : pilatesModal}">
              <div class="modal-background" @click="pilatesModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-pilates">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Pilates Trondheim
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Ilsvika, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Pilates Trondheim</h4>
                      <p class="modal-gym-para">
                        Pilates er en ekstremt målrettet og effektiv form for trening. Fokuset er på utvikling av
                        kjernemuskulatur, og
                        Pilates forbedrer styrke, fleksibilitet, balanse og holdning.
                        Ingen stearinlys eller røkelse ... Pilates handler om resultater.
                        Målet er å styrke og forlenge kroppens muskler for å gjenopprette og forbedre kroppen.
                        Etter bare en økt vil du kjenne deg sterkere og mer energisk! Pilates er også en god
                        form for trening for å forhindre skade. Uansett hvilket treningsnivå du er på vil økten
                        bli tilpasset deg, og du vil bli overrasket over hvordan Pilates kan presse kroppen din
                        på måter du aldri trodde var mulig.
                      </p>
                      <br>
                      <h5 class="title is-5">Fasiliteter</h5>
                      <p class="modal-gym-para">Treningsmatte, omkledningsrom, <s>dusj</s></p>
                      <br>
                      <h5 class="title is-5">Kjekt å vite</h5>
                      <p class="modal-gym-para">Du trenger kun å ha på treningstøy og ta med vannflaske. La joggeskoene bli hjemme.</p>
                      <br>
                      <p class="modal-gym-para">Adresse:</p>
                      <p class="modal-gym-para">Krambugata 14, 7010 Trondheim</p>
                      <br>
                      <a href="http://www.pilatestrondheim.com/" class="subtitle is-5">http://www.pilatestrondheim.com/</a>


                    </div>



                  </div>

                  <div class="column">

                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1784.373173067038!2d10.400312316731384!3d63.433789983278075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d3198ddd3c31f%3A0x2ae44f70e876aad2!2sPilates+Trondheim+AS!5e0!3m2!1sen!2sno!4v1520502650674" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="pilatesModal = false"></button>
            </div>




          </div>

          <!-- Terra yoga -->

          <div class="column is-one-quarter">


            <a class="container" @click="terraModal = true">
              <div class="card has-text-centered yoga-card">




                <div class="title is-4 card-text-test" id="gym-card-title-test">Terra Yoga</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Yoga</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Lilleby, Trondheim</div>


              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : terraModal}">
              <div class="modal-background" @click="terraModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-shankha">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Terra yoga
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Lilleby, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Terra Yoga</h4>
                      <p class="modal-gym-para">
                        Terra Yoga på Lilleby ble startet av Anne Devismes i 2016.
                        Terra Yoga tilbyr klasser i yoga for alle nivåer, fra nybegynnere til
                        mer erfarne utøvere. Alle våre lærere er sertifiserte og med lang erfarne,
                        og vil veilede deg med vennlighet og medfølelse.
                        Yoga er for alle. Uansett hva utgangspunktet vårt er, gir yoga oss en sjanse til å bli koblet igjen
                        med vår egen godhet og indre styrke. Det er et kraftig verktøy som hjelper oss med å utvikle
                        ferdighetene vi trenger for å sette pris på hele spekteret av liv, fra smerte til lykke og fra
                        kaos til fred.

                      </p>
                      <br>
                      <h5 class="title is-5">Fasiliteter</h5>
                      <p class="modal-gym-para">Treningsmatte, omkledningsrom, <s>dusj</s></p>
                      <br>
                      <h5 class="title is-5">Kjekt å vite</h5>
                      <p class="modal-gym-para">Du trenger kun å ha på treningstøy og ta med vannflaske. La joggeskoene bli hjemme.</p>
                      <br>
                      <p class="modal-gym-para">Adresse:</p>
                      <p class="modal-gym-para">Ladeveien 9, 7041 Trondheim</p>
                      <br>
                      <a href="www.terrayoga.no/" class="subtitle is-5">www.terrayoga.no/</a>


                    </div>

                  </div>

                  <div class="column">
                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1783.8424504366506!2d10.433733816241865!3d63.442310783281776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d3199461a077b%3A0x490e8712167b74b1!2sTerra+Yoga!5e0!3m2!1sen!2sno!4v1521537971309" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="terraModal = false"></button>
            </div>

          </div>

          <!-- Heimdal NEW yoga -->

          <div class="column is-one-quarter">


            <a class="container" @click="boulderModal = true">
              <div class="card has-text-centered climbing-card">




                <div class="title is-4 card-text-test" id="gym-card-title-test">Heimdal Klatresenter</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Buldring</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Heimdal, Trondheim</div>

              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : boulderModal}">
              <div class="modal-background" @click="boulderModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-climb">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Heimdal Klatresenter
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Heimdal, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Heimdal Klatresenter</h4>
                      <p class="modal-gym-para">
                        Lørdag 3. oktober 2015 åpnet Heimdal Klatresenter,
                        det eneste klatresenteret på sørsiden i Trondheim. Her finner du ca.
                        200 kvm med buldrevegger; dette vil si klatrevegger med lav høyde og fallsikring bestående av
                        tykke madrasser på bakken. For å buldre behøver man ingen erfaring eller utstyr. Her kan både
                        liten og stor holde seg i aktivitet - klatring er for alle! I tillegg til buldreveggene har de
                        line hvor man kan teste balanseferdighetene, et enkelt styrkerom, spinningsykkel til oppvarming
                        og et bordtennisbord.
                      </p>
                      <br>
                      <h5 class="title is-5">Fasiliteter</h5>
                      <p class="modal-gym-para">Garderobe, dusj</p>
                      <br>
                      <h5 class="title is-5">Kjekt å vite</h5>
                      <p class="modal-gym-para">Du trenger kun å ha på treningstøy og ta med vannflaske. Klatresko får du lånt der gratis i pilotperioden.</p>
                      <br>
                      <p class="modal-gym-para">Adresse:</p>
                      <p class="modal-gym-para">Industriveien 1, 7072 Trondheim</p>
                      <br>
                      <a href="http://www.heimdalklatresenter.no/" class="subtitle is-5">http://www.heimdalklatresenter.no</a>


                    </div>

                  </div>

                  <div class="column">
                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7157.328448585526!2d10.3592921!3d63.3541431!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x47801078b5ce81ae!2sHeimdal+klatresenter!5e0!3m2!1sen!2suk!4v1521453026080" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="boulderModal = false"></button>
            </div>

          </div>

          <!--  Kickboksing NEW yoga -->

          <div class="column is-one-quarter">


            <a class="container" @click="kickModal = true">
              <div class="card has-text-centered kick-card">


                <div class="title is-4 card-text-test" id="gym-card-title-test">Trondheim Kickboksing</div>
                <div class="subtitle is-6 card-text-test" id="type-test">Kickboksing</div>

                <div class="subtitle is-6 card-text-test"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Dora, Trondheim</div>

              </div>
            </a>

            <div class="modal" :class="{ 'is-active' : kickModal}">
              <div class="modal-background" @click="kickModal = false"></div>


              <div class="container" id="gym-modal-container">
                <section id="gym-modal-header-kick">


                  <p class="title has-text-centered" id="modal-gym-title">
                    Trondheim Kickboksing
                  </p>
                  <div class="subtitle is-6 card-text has-text-centered"><i class="fas fa-map-marker-alt fa-1x" id="map-icon"></i> Dora, Trondheim</div>
                </section>

                <div class="columns" id="card-containers">

                  <div class="column is-two-thirds">


                    <div class="container" id="modal-gym-info">
                      <h4 class="title is-4 modal-gym-title">Om Trondheim Kickboksing</h4>
                      <p class="modal-gym-para">
                        <br>
                        Trondheim Kickboxing Klubb ble startet i 1995. Kickboxing er en fysisk idrett med mye kontakt. En slik idrett gir kroppsbeherskelse og god fysisk form.
                        I tillegg er den sosiale delen høyt prioritert. Klubben arrangerer aktiviteter i tillegg til de ordinære treningene.
                        Kickboxing er en utmerket fitness- og konkurransesport, og passer for alle som liker å trene.
                      </p>
                      <br><br><br>
                      <p class="modal-gym-para">Adresse:</p>
                      <p class="modal-gym-para">Båtsmannsgata 4, 7042 Trondheim</p>
                      <br>
                      <a href="tkbk.no" class="subtitle is-5">http://www.tkbk.no</a>


                    </div>

                  </div>

                  <div class="column">
                    <iframe class="map-gym"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1784.0414200708897!2d10.413374316212575!3d63.439116381973385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d31a0a5a177a9%3A0x8682c8895f42a99b!2sTRONDHEIM+KICKBOXING+KLUBB!5e0!3m2!1sen!2sno!4v1522710070420" width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>

                </div>


              </div>

              <button class="modal-close is-large" aria-label="close" @click="kickModal = false"></button>
            </div>

          </div>


        </div>


      </div>


    </div>



  </section>
</template>

<script>
import Firebase from "firebase";
import Classes_overview from './Classes_overview.vue';
import Header from './Header.vue';


export default {
  data() {
    return {
      activeCity: 'Trondheim',

      gymOne: false,
      gymTwo: false,
      gymThree: false,

      shankhaModal: false,
      yogaensModal: false,
      pilatesModal: false,
      climbingModal: false,
      fitnessModal: false,
      terraModal: false,
      boulderModal: false,
      kickModal: false,

    }
  },
  methods: {
    isGymModalActive: function(gym){
      if (gym === 'shankha') {return this.shankhaModal}
      else if (gym === 'yogaens') {return this.yogaensModal}
    },
    launchGymModal: function(gym) {
      if(gym === 'shankha') {this.shankhaModal = true}
      else if (gym === 'yogaens') {this.yogaensModal === true}

    },
    closeGymModal: function() {
      this.shankhaModal = false;
      this.yogaensModal = false;
    },
    activateGym: function (gym){
      if(gym === 'gymOne') {this.gymOne = true}
      else if (gym === 'gymTwo') {this.gymTwo = true}
      else if (gym === 'gymThree') {this.gymThree = true};
    },
    isCollapsed: function(){
      return this.gymTwo;
    },
    isActiveCity: function(city) {
      return this.activeCity === city;
    },
    setActiveCity: function(city) {
      this.activeCity = city;
    },
  },
  components: {
    'classesoverview': Classes_overview,
    navMain: Header
  },
}

</script>

<style lang="scss">

@media screen and (max-width: 768px) {
  .section.gyms{
    padding-top: 80px;
    background-color: #F5F7F9;
    height: 1000px;
  }

  .container {
    font-family: 'system-ui';
  }

  .container.timer.has-text-centered{
    margin-top: 0px;
  }

  .hero-body {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
  }

  div.columns#gymcard {
    max-width: 600px;
  }
  .hero-body:hover {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.10);
    transition: 0.2s;
  }
  .rating {
    height: 30px;
  }

  .map-gym{
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.10);
    transform: scale(0.7);
    margin-left: -60px;
  }

  #btn-expand-gym{
    color: grey;
  }
  #btn-expand-gym:hover{
    color: black;
  }
  #btn-expand-gym-active{
    transform: rotate(-180deg);
  }

  .yoga-card{
    background-image: url("../assets/yoga-tile-test.jpg");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .pilates-card{
    background-image: url("../assets/pilates-tile-test.jpg");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .pilates-card{
    background-image: url("../assets/pilates-tile-test.jpg");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .climbing-card{
    background-image: url("../assets/climb-tile-test.jpg");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .climbing-card-test{
    background-image: url("../assets/climb-tile-test.jpg");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .fitness-card{
    background-image: url("../assets/fitness-tile-test.jpg");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .kick-card{
    background-image: url("../assets/kick-tile-test.png");
    background-position: center;
    height: 150px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 60px;
  }
  .yoga-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .pilates-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .climbing-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .fitness-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .kick-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .climbing-card-test:hover{
    box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
  .card-text{
    color: white;
  }
  .card-text-test{
    color: white;
    text-align: left;
  }
  #type-test{
    margin-bottom: 5px;
  }

  .launch-button{
    background-color: transparent;
    color: #6ccdcb;
    border-radius: 0px;
    font-size: 20px;
  }
  .launch-button:hover{
    background-color: white;
    border-color: white;
    color: #6ccdcb;
    transition: 0.3s;
  }

  section#gym-modal-header-shankha{
    padding: 0px;
    height: 200px;
  }
  section#gym-modal-header-pilates{
    padding: 0px;
    height: 200px;
  }
  section#gym-modal-header-climb{
    padding: 0px;
    height: 200px;
  }
  section#gym-modal-header-fitness{
    padding: 0px;
    height: 200px;
  }
  section#gym-modal-header-kick{
    padding: 0px;
    height: 200px;
  }

  #gym-card-title{
    padding-top: 15px;
  }

  #map-icon{
    color: white;
  }

  .modal-gym-title{
    font-size: 0.95rem;
    max-width: 300px;
  }
  .modal-gym-para{
    font-size: 0.9rem;
    max-width: 300px;
  }

  #gym-modal-header-shankha{
    background-image: url("../assets/yoga-background-modal.png");
    background-position: top;
  }
  #gym-modal-header-pilates{
    background-image: url("../assets/pilates-background.png");
    background-position: top;
  }
  #gym-modal-header-climb{
    background-image: url("../assets/climb-background.png");
    background-position: top;
  }
  #gym-modal-header-fitness{
    background-image: url("../assets/fitness-background.png");
    background-position: top;
  }
  #gym-modal-header-kick{
    background-image: url("../assets/kick-background.png");
    background-position: top;
  }
  #gym-modal-container{
    height: 800px;
    background-color: white;
    overflow-y: auto;
  }

  #modal-gym-title{
    color: white;
    padding-top: 120px;
    font-size: 1.5rem;
  }
  #modal-gym-text{
    color: black;
  }

  #card-containers{
    padding: 50px;
  }

  #modal-gym-info{
    width: 800px;
  }

  #is-static-city{
    color: #D1D1D1;
    text-decoration: line-through;
  }

}

@media screen and (min-width: 768px) {
  .section.gyms{
    padding-top: 120px;
    background-color: #F5F7F9;
    height: 1000px;
  }

  .container {
    font-family: 'system-ui';
  }

  .container.timer.has-text-centered{
    margin-top: 0px;
  }

  .hero-body {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
  }

  div.columns#gymcard {
    max-width: 600px;
  }
  .hero-body:hover {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.10);
    transition: 0.2s;
  }
  .rating {
    height: 30px;
  }

  .map-gym{
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.10);
  }

  #btn-expand-gym{
    color: grey;
  }
  #btn-expand-gym:hover{
    color: black;
  }
  #btn-expand-gym-active{
    transform: rotate(-180deg);
  }

  .yoga-card{
    background-image: url("../assets/yoga-tile-test.jpg");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .pilates-card{
    background-image: url("../assets/pilates-tile-test.jpg");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .pilates-card{
    background-image: url("../assets/pilates-tile-test.jpg");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .climbing-card{
    background-image: url("../assets/climb-tile-test.jpg");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .climbing-card-test{
    background-image: url("../assets/climb-tile-test.jpg");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .fitness-card{
    background-image: url("../assets/fitness-tile-test.jpg");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .kick-card{
    background-image: url("../assets/kick-tile-test.png");
    background-position: center;
    height: 220px;
    width: 400px;
    padding: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    padding-top: 120px;
  }
  .yoga-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .pilates-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .climbing-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .fitness-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .kick-card:hover{
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.18);
    transition: 0.3s;
  }
  .climbing-card-test:hover{
    box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
  .card-text{
    color: white;
  }
  .card-text-test{
    color: white;
    text-align: left;
  }
  #type-test{
    margin-bottom: 5px;
  }

  .launch-button{
    background-color: transparent;
    color: #6ccdcb;
    border-radius: 0px;
    font-size: 20px;
  }
  .launch-button:hover{
    background-color: white;
    border-color: white;
    color: #6ccdcb;
    transition: 0.3s;
  }

  section#gym-modal-header-shankha{
    padding: 0px;
    height: 300px;
  }
  section#gym-modal-header-pilates{
    padding: 0px;
    height: 300px;
  }
  section#gym-modal-header-climb{
    padding: 0px;
    height: 300px;
  }
  section#gym-modal-header-fitness{
    padding: 0px;
    height: 300px;
  }
  section#gym-modal-header-kick{
    padding: 0px;
    height: 300px;
  }

  #gym-card-title{
    padding-top: 15px;
  }

  #map-icon{
    color: white;
  }

  #gym-modal-header-shankha{
    background-image: url("../assets/yoga-background-modal.png");
    background-position: top;
  }
  #gym-modal-header-pilates{
    background-image: url("../assets/pilates-background.png");
    background-position: top;
  }
  #gym-modal-header-climb{
    background-image: url("../assets/climb-background.png");
    background-position: top;
  }
  #gym-modal-header-fitness{
    background-image: url("../assets/fitness-background.png");
    background-position: top;
  }
  #gym-modal-header-kick{
    background-image: url("../assets/kick-background.png");
    background-position: top;
  }
  #gym-modal-container{
    height: 800px;
    background-color: white;
    overflow-y: auto;
  }


  #modal-gym-title{
    color: white;
    padding-top: 100px;
  }
  #modal-gym-text{
    color: black;
  }

  #card-containers{
    padding: 50px;
  }

  #modal-gym-info{
    width: 800px;
  }

  #is-static-city{
    color: #D1D1D1;
    text-decoration: line-through;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gyms.vue